const TRADER_CONSTANTS = {
  TRADER_ACCOUNTS: 'TraderAccounts',
  TRADER_INVENTORY: 'TraderInventory',
  TRADER_UPLOAD: 'TraderUpload',
  OPS_TRADER_LIST: 'OpsTraderList',
};
export default TRADER_CONSTANTS;
